/**
 * Illustrations and annotations for the Hour of Code page.
 */

import {t} from "@lingui/core/macro";
import {css, StyleSheet} from "aphrodite";
import * as React from "react";

import {mediaQueries} from "@khan/shared-styles";
import {staticUrl} from "@khan/urls";

import {BackgroundBlob} from "#marketing-content-shared-package/background-blob.tsx";
import LastChanceCollage from "#marketing-content-shared-package/collages/last-chance.tsx";
import IllustrationContext from "#marketing-content-shared-package/illustration-context.ts";
import {MediaScrollButton} from "#marketing-content-shared-package/media-scroll-button.tsx";

type Props = {
    children: React.ReactNode;
};

const HourOfDrawing = () => {
    return (
        <img
            className={css(styles.circleImg)}
            alt={t`penguin: A project from Hour of Code last year, courtesy of Lydia.`}
            src={staticUrl("/images/hour_of_code/js.png")}
        />
    );
};

const HourOfWebpages = () => {
    return (
        <img
            className={css(styles.circleImg)}
            alt={t`An illustration of a webpage about holidays`}
            src={staticUrl("/images/hour_of_code/html_css.png")}
        />
    );
};

const HourOfDatabases = () => {
    return (
        <img
            className={css(styles.circleImg)}
            alt={t`An illustration of a computer database`}
            src={staticUrl("/images/hour_of_code/sql.png")}
        />
    );
};

const InClassroom = () => {
    return (
        <img
            alt=""
            className={css(styles.inClassroom)}
            src={staticUrl("/images/hour_of_code/inclassroom_collage.png")}
        />
    );
};

const MoreJS = () => {
    return (
        <img
            alt=""
            className={css(styles.leftImg)}
            src={staticUrl("/images/hour_of_code/more_js_collage.png")}
        />
    );
};

const MoreHTML = () => {
    return (
        <img
            alt=""
            className={css(styles.rightImg)}
            src={staticUrl("/images/hour_of_code/more_html_collage.png")}
        />
    );
};

const MoreSQL = () => {
    return (
        <img
            alt=""
            className={css(styles.leftImg)}
            src={staticUrl("/images/hour_of_code/more_sql_collage.png")}
        />
    );
};

export default class Media extends React.Component<Props> {
    render(): React.ReactNode {
        const {children} = this.props;

        return (
            <IllustrationContext.Provider
                value={{
                    BackgroundBlob,
                    ScrollButton: MediaScrollButton,
                    InClassroom,
                    MoreJS,
                    MoreHTML,
                    MoreSQL,
                    LastChanceCollage,
                    HourOfDrawing,
                    HourOfWebpages,
                    HourOfDatabases,
                }}
            >
                {children}
            </IllustrationContext.Provider>
        );
    }
}

const styles = StyleSheet.create({
    circleImg: {
        height: 135,
    },
    inClassroom: {
        margin: "auto",

        [mediaQueries.smOrSmaller]: {
            width: "115%",
            marginLeft: "3%",
        },
        [mediaQueries.md]: {
            width: "87%",
            marginLeft: "25%",
        },
        [mediaQueries.lgOrLarger]: {
            width: "130%",
            margin: "initial",
            marginLeft: "8%",
            transform: "translateY(-35px)",
        },
    },
    leftImg: {
        margin: "auto",

        [mediaQueries.smOrSmaller]: {
            width: "120%",
            marginLeft: "-10%",
            marginBottom: 20,
        },
        [mediaQueries.md]: {
            width: "90%",
            marginBottom: 20,
        },
        [mediaQueries.lgOrLarger]: {
            width: "105%",
            margin: "initial",
            marginLeft: "-10%",
        },
    },
    rightImg: {
        margin: "auto",

        [mediaQueries.smOrSmaller]: {
            width: "115%",
            marginLeft: "3%",
        },
        [mediaQueries.md]: {
            width: "87%",
            marginLeft: "25%",
        },
        [mediaQueries.lgOrLarger]: {
            width: "130%",
            margin: "initial",
            transform: "translateY(-35px)",
        },
    },
});
